var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},_vm._l((_vm.cards),function(card){return _c('Card',{key:card.id,attrs:{"content":card}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }